<template>
  <BaseModalEditCreate
    mode="add"
    title="Add Module"
    :is-modified="false"
    v-if="modules"
    @save="onSave"
    @dismiss-changes="onCancel">
    <template #form>
      <div class="relative space-y-3 overflow-auto h-96">
        <button
          type="button"
          v-for="module in modules"
          :key="module.id"
          @click="onSelectModule(module)"
          class="flex items-center justify-between w-full px-2 py-2 font-light transition-all duration-300 border rounded-md cursor-pointer"
          :class="[
            module.appName
              ? 'text-gray-400'
              : 'hover:border-theme-500 hover:text-theme-700 hover:shadow-sm',
            selectedModules.some((selectedModule) => selectedModule.id === module.id)
              ? 'border-theme-500 text-theme-700 shadow-sm'
              : '',
          ]">
          {{ module.displayName }}
          <span
            v-if="module.appName"
            class="bg-gray-100 text-gray-500 text-xs me-2 px-2.5 py-0.5 rounded font-light"
            >{{ module.appName }}</span
          >
          <span
            v-if="selectedModules.some((selectedModule) => selectedModule.id === module.id)"
            class="flex items-center pr-4 text-theme-600 group-hover:text-white">
            <svg class="w-5 h-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path
                fill-rule="evenodd"
                d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
                clip-rule="evenodd" />
            </svg>
          </span>
        </button>
      </div>
    </template>
  </BaseModalEditCreate>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import BaseModalEditCreate from '../common/BaseModalEditCreate.vue';
import type { MWModule } from '@/types/MW';

withDefaults(
  defineProps<{
    modules: MWModule[];
  }>(),
  {}
);

const emit = defineEmits(['close', 'save']);

const selectedModules = ref<MWModule[]>([]);

function onSelectModule(module: MWModule) {
  if (module.appName) return;
  // selectedModules.value.push(module);
  const index = selectedModules.value.findIndex(
    (selectedModule) => selectedModule.id === module.id
  );
  if (index === -1) {
    selectedModules.value.push(module); // Add module if it's not already selected
  } else {
    selectedModules.value.splice(index, 1); // Remove module if it's already selected
  }
}

function onSave() {
  emit('save', selectedModules.value);
  selectedModules.value = [];
}
function onCancel() {
  emit('close');
  selectedModules.value = [];
}
</script>
